import { render } from "./WatchHits.vue?vue&type=template&id=680323e3&scoped=true&lang=pug"
import script from "./WatchHits.vue?vue&type=script&lang=js"
export * from "./WatchHits.vue?vue&type=script&lang=js"

import "./WatchHits.vue?vue&type=style&index=0&id=680323e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680323e3"]])

export default __exports__